import * as Sentry from "@sentry/browser";
import AppWindow from "./app-window";

/**
 * Initializes Sentry for error tracking and monitoring.
 *
 * This function configures Sentry with the necessary settings such as DSN, environment,
 * release version, and a list of errors to ignore. It retrieves these settings from
 * the global `AppWindow` object and environment variables.
 */
export default function initializeSentry() {
  const appWindow = AppWindow() as any;
  const appVersion = process.env.REACT_APP_VERSION || "unknownversion";
  const sentryDSN = appWindow.STUDENT_ENV.REACT_APP_SENTRY_DSN || "";
  const appEnv = appWindow.STUDENT_ENV.REACT_APP_ENV || "";

  Sentry.init({
    dsn: sentryDSN,
    environment: appEnv,
    release: appVersion,
    ignoreErrors: [
      "Failed to execute 'setStart' on 'Range'",
      "Cannot read properties of undefined (reading 'timeupdate')",
      "Cannot read properties of undefined (reading 'emptied')",
      "Cannot read properties of undefined (reading 'abort')",
      "The request is not allowed by the user agent or the platform in the current context,",
      "AbortError: The play() request was interrupted by a call to pause()",
      "AbortError: The play() request was interrupted by a new load request",
      "No activity attempt found for take"
    ]
  });
}